import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './login/login.component';
import { SignupComponent } from './signup/signup.component';
import { OtpComponent } from './otp/otp.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HelpComponent } from '../help/help.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { NewLoginComponent } from './login/new-login/new-login.component';
@NgModule({
  declarations: [
    LoginComponent,
    SignupComponent,
    OtpComponent,HelpComponent,NewLoginComponent
  ],
  imports: [
    CommonModule,
    LoginRoutingModule,NgOtpInputModule,FormsModule,
    ReactiveFormsModule,NgxPaginationModule
  ],
  exports:[OtpComponent,SignupComponent],
  providers: [],
})
export class LoginModule { }
